import { List } from "@mui/material"
import { styled } from "@mui/material/styles"

const StyledList = styled(List)(({ theme }) => ({
  padding: "0",
  marginTop: "0",
  borderRadius: "10px",
  boxShadow: "0px 0px 15px 0px rgb(0 0 0 / 4%)"
}))

export const TodoListWrapper = ({ children, style }) => {
  return <StyledList style={style}>{children}</StyledList>
}
